import httpClient from "./httpClient";

class PostsApi {
    getPosts = async ({perPage = 15, page = 1, categories = [], postNotIn = null}) => {
        const response = await httpClient.get('/cheap-study/v1/posts/', {
            params: {
                per_page: perPage,
                page,
                categories,
                post__not_in: postNotIn,
            }
        });
        return {
            data: response.data,
            pages: Number(response.headers.get('X-Total-Pages')),
            posts: Number(response.headers.get('X-Total-Posts')),
        };
    }
}

export const postsApi = new PostsApi();